import React from 'react'

import { Swiper, SwiperSlide } from "swiper/react";

import employ1 from "../../../assets/images/homeImages/employImg/1681811079610.png";
import employ2 from "../../../assets/images/homeImages/employImg/Leroy_Merlin_logo_logotype_emblem.png";
import employ3 from "../../../assets/images/homeImages/employImg/WTWS_primary-logo-navy.png";
import employ4 from "../../../assets/images/homeImages/employImg/th (14).png";
import employ5 from "../../../assets/images/homeImages/employImg/th (2).png";
import employ6 from "../../../assets/images/homeImages/employImg/with-intelligence-logo-white.png";

const Client = () => {
  return (
    <div>
       <Swiper
              slidesPerView={5}
              loop={true}
              // grabCursor={true}
              className="mySwiper"
              breakpoints={{
                0: {
                  slidesPerView: 2,
                },
                320: {
                  slidesPerView: 2,
                },
                400: {
                  slidesPerView: 2,
                },
                639: {
                  slidesPerView: 3,
                },
                865: {
                  slidesPerView: 4,
                },
                900: {
                  slidesPerView: 4,
                },
                1000: {
                  slidesPerView: 4,
                },
                1200: {
                  slidesPerView: 4,
                },
                1300: {
                  slidesPerView: 5,
                },
                1500: {
                  slidesPerView: 5,
                },
                1700: {
                  slidesPerView: 5,
                },
              }}
            >
              <SwiperSlide>
                <img className="client-img-s" src={employ4} alt="" />
              </SwiperSlide>

              <SwiperSlide>
                <img className="client-img-s lient-img-cipd" src={employ1} alt="" />
              </SwiperSlide>

              <SwiperSlide>
                <img className="client-img-s" src={employ3} alt="" />
              </SwiperSlide>

              <SwiperSlide>
                <img className="client-img-s client-img-grev" src={employ5} alt="" />
              </SwiperSlide>

              <SwiperSlide>
                <img className="client-img-s " src={employ6} alt="" />
              </SwiperSlide>

              <SwiperSlide>
                <img className="client-img-s" src={employ2} alt="" />
              </SwiperSlide>
            </Swiper>
    </div>
  )
}

export default Client
